import {
  DashboardModuleListItem, Image,
} from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'
import usePriorityCampaign from '@hooks/usePriorityCampaign'

import type { PriorityCampaignModel } from '@models/types'

import { confirmDelete } from '@functions/entity'

import placeholderImageUrl from '../../assets/campaign_image_400x400.png'

interface PriorityCampaignListItemProps {
  priorityCampaign: PriorityCampaignModel,
}

const PriorityCampaignListItem = (props: PriorityCampaignListItemProps) => {
  const {
    priorityCampaign,
  } = props

  const priorityCampaignPayload = usePriorityCampaign(priorityCampaign)
  const {
    callbacks: { deletePriorityCampaign: deleteFn },
    priorityCampaign: { campaign_id: campaignId },
  } = priorityCampaignPayload

  const campaignPayload = useCampaign({ id: campaignId })
  const { campaign } = campaignPayload

  const {
    address,
    default_image,
    suburb_name,
  } = campaign || {}

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This will remove the priority status of this campaign for the user.',
      deleteString: 'Remove',
      entityName: 'Priority Campaign',
    },
  }

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 0 }}
      imageComponent={(
        <Image
          backgroundSize="cover"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          placeholderUrl={placeholderImageUrl}
          url={default_image}
        />
      )}
      isSidebar
      secondaryText={suburb_name}
      title={address}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default PriorityCampaignListItem
